import React, { useCallback } from 'react';
import { TMenuContentVersion } from 'types';
import { Checkbox, Form } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import Text from 'components/Text/Text';

interface IUseCustomerMenuVersionCheckBox {
	toggleUseMenuVersion: (value: TMenuContentVersion) => void;
	useMenuVersion: TMenuContentVersion;
}

const UseCustomerMenuVersionCheckBox: React.FC<IUseCustomerMenuVersionCheckBox> = ({
	toggleUseMenuVersion,
	useMenuVersion,
}) => {
	const handleChange = useCallback(
		(e: CheckboxChangeEvent) => {
			if (e.target.checked) {
				toggleUseMenuVersion('Customer');
			} else {
				toggleUseMenuVersion('None');
			}
		},
		[toggleUseMenuVersion],
	);

	return (
		<Form.Item name="useMenuVersion">
			<Checkbox checked={useMenuVersion === 'Customer'} onChange={handleChange}>
				<Text translationNameSpace="form" translationKey="useCustomerMenuVersionLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(UseCustomerMenuVersionCheckBox);
